import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
function WalkInSnackBar({ state, handleClose }) {
  return (
    <Snackbar
      open={state.open}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      TransitionComponent={SlideTransition}
      autoHideDuration={6000}
      onClose={handleClose}
      key={SlideTransition.name}
    >
      <Alert
        onClose={handleClose}
        severity={state.type}
        variant="filled"
        sx={{ width: "100%", fontFamily: "Poppins-SemiBold" }}
      >
        {state.message}
      </Alert>
    </Snackbar>
  );
}

export default WalkInSnackBar;
